// import React, { useEffect } from "react";
// import { Typography, Avatar, Box, Paper, Divider, Grid } from "@mui/material";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchpartnerbyId } from "../../redux/slices/partnerSlice";
// import Loader from "../../comman/Loader";
// import { AccountCircle } from "@mui/icons-material";

// const PartnerProfile = () => {
//   const partner = useSelector((state) => state?.partner);
//   const data = partner?.fetchById;
//   const loading = partner?.loading;
//   const partnerId = JSON.parse(sessionStorage.getItem("user"));

//   const dispatch = useDispatch();

//   useEffect(() => {
//     if (!data) {
//       dispatch(fetchpartnerbyId(partnerId?.userId));
//     }
//   }, [data, dispatch, partnerId]);

//   if (!data && loading) {
//     return <Loader />;
//   }

//   return (
//     <Box
//       maxWidth={700}
//       mx="auto"
//       mt={3}
//       p={2}
//       component={Paper}
//       elevation={6}
//       borderRadius={4}
//       sx={{
//         backgroundColor: "#ffffff",
//         boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//       }}
//     >
//       {/* Profile Header */}
//       <Box display="flex" alignItems="center" gap={3}>
//         <Avatar
//           sx={{
//             width: 60,
//             height: 60,
//             bgcolor: "#1E88E5",
//             boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
//           }}
//         >
//           {data?.userId?.picture ? (
//             <img
//               src={data?.userId?.picture}
//               alt="Profile"
//               style={{ width: "100%", height: "100%", borderRadius: "50%" }}
//             />
//           ) : (
//             <AccountCircle sx={{ fontSize: 60, color: "white" }} />
//           )}
//         </Avatar>
//         <Box>
//           <Typography variant="h6" fontWeight={700} color="#1E88E5">
//             {data?.name}
//           </Typography>
//         </Box>
//       </Box>

//       <Divider sx={{ my: 3, backgroundColor: "#E0E0E0" }} />

//       {/* Partner Details in Grid */}
//       <Grid container spacing={2}>
//         {[
//           { label: "Email", value: data?.email },
//           { label: "Phone", value: data?.mobile },
//           { label: "Experience", value: data?.experience },
//           { label: "Total Earnings", value: `₹${data?.totalEarnings}` },
//           { label: "Commission Rate", value: `${data?.commissionRate}%` },
//           { label: "Bank Name", value: data?.bankDetails?.bankName },
//           { label: "Account Number", value: data?.bankDetails?.accountNumber },
//           { label: "IFSC Code", value: data?.bankDetails?.ifscCode },
//           {
//             label: "Joined On",
//             value: new Date(data?.updatedAt).toLocaleDateString(),
//           },
//         ].map((item, index) => (
//           <Grid item xs={12} md={6} key={index}>
//             <Box
//               display="flex"
//               justifyContent="space-between"
//               alignItems="center"
//               p={1.5}
//               sx={{
//                 backgroundColor: "#E3F2FD",
//                 borderRadius: 2,
//                 boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
//               }}
//             >
//               <Typography variant="body1" fontWeight={600} color="#1E88E5">
//                 {item.label}:
//               </Typography>
//               <Typography variant="body1" fontWeight={500} color="#424242">
//                 {item.value}
//               </Typography>
//             </Box>
//           </Grid>
//         ))}
//       </Grid>
//     </Box>
//   );
// };

// export default PartnerProfile;

// import React, { useEffect, useState } from "react";
// import {
//   Typography,
//   Avatar,
//   Box,
//   Paper,
//   Divider,
//   Grid,
//   Button,
//   Snackbar,
//   Alert,
// } from "@mui/material";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchpartnerbyId } from "../../redux/slices/partnerSlice";
// import Loader from "../../comman/Loader";
// import { AccountCircle } from "@mui/icons-material";
// import { requestWithdrawal } from "../../redux/WithdralSlice/withdrawalSlice";

// const PartnerProfile = () => {
//   const partner = useSelector((state) => state?.partner);
//   const data = partner?.fetchById;
//   const loading = partner?.loading;
//   const partnerId = JSON.parse(sessionStorage.getItem("user"));
//   // console.log("data", data?.userId?._id);
//   const userId = data?.userId?._id;

//   const dispatch = useDispatch();
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "info",
//   });

//   useEffect(() => {
//     if (!data) {
//       dispatch(fetchpartnerbyId(partnerId?.userId));
//     }
//   }, [data, dispatch, partnerId]);

//   if (!data && loading) {
//     return <Loader />;
//   }

//   const handleWithdraw = () => {
//     if (data?.totalEarnings < 500) {
//       setSnackbar({
//         open: true,
//         message: "Minimum withdrawal amount is ₹500",
//         severity: "warning",
//       });
//       return;
//     }

//     if (!data?.bankDetails?.accountNumber || !data?.bankDetails?.ifscCode) {
//       setSnackbar({
//         open: true,
//         message: "Bank details are missing. Update them first!",
//         severity: "error",
//       });
//       return;
//     }

//     const withdrawalAmount = data?.totalEarnings;

//     dispatch(
//       requestWithdrawal({
//         userId,
//         amount: withdrawalAmount,
//       })
//     ).then((res) => {
//       if (res?.payload?.withdrawal) {
//         setSnackbar({
//           open: true,
//           message: "Withdrawal request sent!",
//           severity: "success",
//         });
//       } else {
//         setSnackbar({
//           open: true,
//           message: res?.payload?.message || "Failed to request withdrawal",
//           severity: "error",
//         });
//       }
//     });
//   };

//   return (
//     <Box
//       maxWidth={700}
//       mx="auto"
//       mt={3}
//       p={2}
//       component={Paper}
//       elevation={6}
//       borderRadius={4}
//       sx={{
//         backgroundColor: "#ffffff",
//         boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//       }}
//     >
//       {/* Profile Header */}
//       <Box display="flex" alignItems="center" gap={3}>
//         <Avatar
//           sx={{
//             width: 60,
//             height: 60,
//             bgcolor: "#1E88E5",
//             boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
//           }}
//         >
//           {data?.userId?.picture ? (
//             <img
//               src={data?.userId?.picture}
//               alt="Profile"
//               style={{ width: "100%", height: "100%", borderRadius: "50%" }}
//             />
//           ) : (
//             <AccountCircle sx={{ fontSize: 60, color: "white" }} />
//           )}
//         </Avatar>
//         <Box>
//           <Typography variant="h6" fontWeight={700} color="#1E88E5">
//             {data?.name}
//           </Typography>
//         </Box>
//       </Box>

//       <Divider sx={{ my: 3, backgroundColor: "#E0E0E0" }} />

//       {/* Partner Details in Grid */}
//       <Grid container spacing={2}>
//         {[
//           { label: "Email", value: data?.email },
//           { label: "Phone", value: data?.mobile },
//           { label: "Experience", value: data?.experience },
//           { label: "Total Earnings", value: `₹${data?.totalEarnings}` },
//           { label: "Commission Rate", value: `${data?.commissionRate}%` },
//           { label: "Bank Name", value: data?.bankDetails?.bankName },
//           { label: "Account Number", value: data?.bankDetails?.accountNumber },
//           { label: "IFSC Code", value: data?.bankDetails?.ifscCode },
//           {
//             label: "Joined On",
//             value: new Date(data?.updatedAt).toLocaleDateString(),
//           },
//         ].map((item, index) => (
//           <Grid item xs={12} md={6} key={index}>
//             <Box
//               display="flex"
//               justifyContent="space-between"
//               alignItems="center"
//               p={1.5}
//               sx={{
//                 backgroundColor: "#E3F2FD",
//                 borderRadius: 2,
//                 boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
//               }}
//             >
//               <Typography variant="body1" fontWeight={600} color="#1E88E5">
//                 {item.label}:
//               </Typography>
//               <Typography variant="body1" fontWeight={500} color="#424242">
//                 {item.value}
//               </Typography>
//             </Box>
//           </Grid>
//         ))}
//       </Grid>

//       {/* Withdraw Button */}
//       <Box textAlign="center" mt={3}>
//         <Button
//           variant="contained"
//           color="primary"
//           onClick={handleWithdraw}
//           disabled={data?.totalEarnings < 500}
//         >
//           Withdraw Earnings
//         </Button>
//       </Box>

//       {/* Snackbar Notification */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={4000}
//         onClose={() => setSnackbar({ ...snackbar, open: false })}
//       >
//         <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default PartnerProfile;

import React, { useEffect, useState } from "react";
import {
  Typography,
  Avatar,
  Box,
  Paper,
  Divider,
  Grid,
  Button,
  Snackbar,
  Alert,
  TextField,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchpartnerbyId } from "../../redux/slices/partnerSlice";
import Loader from "../../comman/Loader";
import { AccountCircle } from "@mui/icons-material";
import { requestWithdrawal } from "../../redux/WithdralSlice/withdrawalSlice";

const PartnerProfile = () => {
  const dispatch = useDispatch();
  const partner = useSelector((state) => state?.partner);
  const data = partner?.fetchById;
  const loading = partner?.loading;
  const partnerId = JSON.parse(sessionStorage.getItem("user"));
  const userId = data?.userId?._id;

  const [withdrawalAmount, setWithdrawalAmount] = useState("");
  const [updatedEarnings, setUpdatedEarnings] = useState(
    data?.totalEarnings || 0
  );
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  useEffect(() => {
    if (!data) {
      dispatch(fetchpartnerbyId(partnerId?.userId));
    }
  }, [data, dispatch, partnerId]);

  useEffect(() => {
    if (data) {
      setUpdatedEarnings(data.totalEarnings);
    }
  }, [data]);

  if (!data && loading) {
    return <Loader />;
  }

  const handleWithdraw = () => {
    const amount = parseFloat(withdrawalAmount);

    if (isNaN(amount) || amount < 500) {
      setSnackbar({
        open: true,
        message: "Minimum withdrawal amount is ₹500",
        severity: "warning",
      });
      return;
    }

    if (amount > updatedEarnings) {
      setSnackbar({
        open: true,
        message: "Insufficient balance!",
        severity: "error",
      });
      return;
    }

    if (!data?.bankDetails?.accountNumber || !data?.bankDetails?.ifscCode) {
      setSnackbar({
        open: true,
        message: "Bank details are missing. Update them first!",
        severity: "error",
      });
      return;
    }

    dispatch(requestWithdrawal({ userId, amount })).then((res) => {
      if (res?.payload?.withdrawal) {
        setSnackbar({
          open: true,
          message: "Withdrawal request sent!",
          severity: "success",
        });
        setWithdrawalAmount("");
        setUpdatedEarnings((prev) => prev - amount);
      } else {
        setSnackbar({
          open: true,
          message: res?.payload?.message || "Failed to request withdrawal",
          severity: "error",
        });
      }
    });
  };

  return (
    <Box
      maxWidth={700}
      mx="auto"
      mt={3}
      p={2}
      component={Paper}
      elevation={6}
      borderRadius={4}
      sx={{
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      }}
    >
      {/* Profile Header */}
      <Box display="flex" alignItems="center" gap={3}>
        <Avatar
          sx={{
            width: 60,
            height: 60,
            bgcolor: "#1E88E5",
            boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
          }}
        >
          {data?.userId?.picture ? (
            <img
              src={data?.userId?.picture}
              alt="Profile"
              style={{ width: "100%", height: "100%", borderRadius: "50%" }}
            />
          ) : (
            <AccountCircle sx={{ fontSize: 60, color: "white" }} />
          )}
        </Avatar>
        <Box>
          <Typography variant="h6" fontWeight={700} color="#1E88E5">
            {data?.name}
          </Typography>
        </Box>
      </Box>

      <Divider sx={{ my: 3, backgroundColor: "#E0E0E0" }} />

      {/* Partner Details */}
      <Grid container spacing={2}>
        {[
          { label: "Email", value: data?.email },
          { label: "Phone", value: data?.mobile },
          { label: "Experience", value: data?.experience },
          { label: "Total Earnings", value: `₹${updatedEarnings}` },
          { label: "Commission Rate", value: `${data?.commissionRate}%` },
          { label: "Bank Name", value: data?.bankDetails?.bankName },
          { label: "Account Number", value: data?.bankDetails?.accountNumber },
          { label: "IFSC Code", value: data?.bankDetails?.ifscCode },
          {
            label: "Joined On",
            value: new Date(data?.updatedAt).toLocaleDateString(),
          },
        ].map((item, index) => (
          <Grid item xs={12} md={6} key={index}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={1.5}
              sx={{
                backgroundColor: "#E3F2FD",
                borderRadius: 2,
                boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
              }}
            >
              <Typography variant="body1" fontWeight={600} color="#1E88E5">
                {item.label}:
              </Typography>
              <Typography variant="body1" fontWeight={500} color="#424242">
                {item.value}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Withdrawal Input and Button */}
      <Box textAlign="center" mt={3}>
        <TextField
          label="Enter Withdrawal Amount"
          variant="outlined"
          type="number"
          value={withdrawalAmount}
          onChange={(e) => setWithdrawalAmount(e.target.value)}
          fullWidth
          sx={{ mb: 2 }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleWithdraw}
          disabled={updatedEarnings < 500}
          sx={{ textTransform: "capitalize" }}
        >
          Withdraw Earnings
        </Button>
      </Box>

      {/* Snackbar Notification */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
};

export default PartnerProfile;
